<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.058 2.305a1.04 1.04 0 0 1 1.472 0l2.165 2.17a1.043 1.043 0 0 1 0 1.473L7.635 16.025l-3.638-3.643L14.058 2.305ZM3.344 13.201 2.067 16.59a1.043 1.043 0 0 0 1.332 1.346l3.417-1.257-3.472-3.478Z" />
    </svg>
</template>
